import { rem } from 'design-system/values';
import IconMerchant from 'design-system/icons/IconMerchant';
import { IconSettings } from 'design-system/icons/IconSettings';
import { IconBank, IconBoldCalendar, IconLightBulb } from 'design-system/icons';
import IconTag from './icons/toolbar/IconTag';
import IconAmountUpper from './icons/toolbar/IconAmountUpper';
import IconAmountLower from './icons/toolbar/IconAmountLower';
import IconReceipt from './icons/toolbar/IconReceipt';
export const TOOLBAR_BUTTONS = [
    {
        Icon: IconLightBulb,
        keyboardName: 'KeyboardCategories',
    },
    {
        Icon: IconMerchant,
        keyboardName: 'KeyboardMerchants',
    },
    {
        Icon: IconTag,
        keyboardName: 'KeyboardTags',
    },
    {
        Icon: IconAmountLower,
        keyboardName: 'KeyboardAmountLower',
    },
    {
        Icon: IconAmountUpper,
        keyboardName: 'KeyboardAmountUpper',
    },
    {
        Icon: IconBoldCalendar,
        keyboardName: 'KeyboardDates',
    },
    {
        Icon: IconReceipt,
        keyboardName: 'KeyboardReceipts',
    },
    {
        Icon: IconBank,
        keyboardName: 'KeyboardAccounts',
    },
    {
        Icon: IconSettings,
        keyboardName: 'KeyboardSettings',
    },
];
export const MARGIN_HORIZONTAL = rem(16);
export const INNER_MARGIN = rem(8);
export const TOOLBAR_PADDING_VERTICAL = rem(8);
export const calculateSize = (width) => {
    const innerWidth = width - 2 * MARGIN_HORIZONTAL;
    const allMargins = INNER_MARGIN * (TOOLBAR_BUTTONS.length - 1);
    return (innerWidth - allMargins) / TOOLBAR_BUTTONS.length;
};
